import Avatar from "@material-ui/core/Avatar";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import { formatDate } from "helper/dateFormat";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import AssignTo from "../../../assets/icons/AssignTo.svg";
import BlueCheck from "../../../assets/icons/Blue-check.svg";
import BlueNotifi from "../../../assets/icons/Blue-notifi.svg";
import Delete from "../../../assets/icons/Delete.svg";
import Email from "../../../assets/icons/mail.svg";
import Call from "../../../assets/icons/phone.svg";
import Message from "../../../assets/icons/sms.svg";
import DropIcon from "../../../assets/media/svg/icons/General/Other2.svg";
import { fullNameFirstLetter } from "../helper/getFirstChartFromFullName";
import "./styles.scss";

const Task = ({
  data,
  taskAvatar,
  taskBackground,
  taskColor,
  taskTitle,
  taskDes,
  firstName,
  lastName,
  date,
  dateType,
  subject,
  content,
  email,
  phone,
  suggestionText,
  openAssignTaskModalHandler,
  openSnoozeModalHandler,
  updateTaskHandler,
  onContactClick,
  onEventClick,
  onDeleteTask,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [toggleTaskCard, setToggleTaskCard] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleMenuOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleMenuClose = () => setAnchorEl(null);
  const menuOpen = Boolean(anchorEl);

  const mailTo = () => {
    const subj = encodeURIComponent(subject || "");
    const body = encodeURIComponent(content || "");
    const params = subj ? `subject=${subj}&body=${body}` : `body=${body}`;
    return `mailto:${email || ""}?${params}`;
  };
  const smsTo = () => {
    const num = (phone || "").replace(/[^0-9]/g, "");
    const body = encodeURIComponent(content || "");
    return `sms:${num}?body=${body}`;
  };
  const phoneTo = () => `tel:${(phone || "").replace(/[^0-9]/g, "")}`;

  const markAsCompleteHandler = () => {
    updateTaskHandler({
      key: 1,
      id: data.id,
      successMsg: "Task marked as complete Successfully",
    });
    handleMenuClose();
  };
  const deleteTaskHandler = () => {
    onDeleteTask(data.id);
    handleMenuClose();
  };
  const onSnooze = () => {
    openSnoozeModalHandler(data);
    handleMenuClose();
  };
  const onAssign = () => {
    openAssignTaskModalHandler(data);
    handleMenuClose();
  };
  const displayDate = () =>
    dateType === "earlier"
      ? formatDate({ date, formatType: "defaultWithUtc" })
      : dateType;

  const toggleTaskCardHandler = () => {
    setToggleTaskCard((s) => !s);
  };

  const copyAddressHandler = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(suggestionText || "");
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="pastoral__event-task mb-5" onClick={toggleTaskCardHandler}>
      <div className="hover-border" />
      <div className="task p-5 w-100" style={{ background: taskBackground }}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Avatar className="mr-4" alt="" src={taskAvatar}>
              {fullNameFirstLetter(firstName, lastName)?.toUpperCase()}
            </Avatar>
            <div>
              <h6
                className="task-title m-0 pastoral__task-title cursor-pointer"
                style={{ color: taskColor }}
                onClick={(e) => {
                  e.stopPropagation();
                  onContactClick(data);
                }}
              >
                {taskTitle}
              </h6>
              <p
                className="task-des pastoral__task-event cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onEventClick(data);
                }}
              >
                {taskDes}
              </p>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <p className="m-0 text-capitalize" style={{ color: "#7B7B8B" }}>
              {displayDate()}
            </p>
            <div
              className="ml-3 cursor-pointer"
              onClick={handleMenuOpen}
            >
              <img src={DropIcon} width="24" height="24" />
            </div>
          </div>
        </div>

        {toggleTaskCard && (
          <div className="pastoral__event-task__desc mt-4 d-flex align-items-start">
            <p className="flex-grow-1">{suggestionText}</p>
            <div
              className="cursor-pointer position-relative pastoral__event-task-copy"
              onClick={copyAddressHandler}
            >
              <ContentCopyIcon sx={{ color: "#30557C", width: "16px" }} />
              {isCopied && (
                <div className="copy-value__hint">Copied</div>
              )}
            </div>
          </div>
        )}
      </div>

      <Popover
        open={menuOpen}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: { maxHeight: 300, width: 200, zIndex: 1300 },
        }}
				className={"popover__menu__task"}
      >
        <MenuItem
          onClick={() => {
            window.open(smsTo(), "_blank");
            handleMenuClose();
          }}
        >
          <img src={Message} className="mr-2" /> Message Member
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open(mailTo(), "_blank");
            handleMenuClose();
          }}
        >
          <img src={Email} className="mr-2" /> Email Member
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open(phoneTo(), "_blank");
            handleMenuClose();
          }}
        >
          <img src={Call} className="mr-2" /> Call Member
        </MenuItem>
        <MenuItem onClick={markAsCompleteHandler}>
          <img src={BlueCheck} className="mr-2" /> Mark As Complete
        </MenuItem>
        <MenuItem onClick={onSnooze}>
          <img src={BlueNotifi} className="mr-2" /> Snooze
        </MenuItem>
        <MenuItem onClick={onAssign}>
          <img src={AssignTo} className="mr-2" /> Assign Task To
        </MenuItem>
        <MenuItem
          onClick={deleteTaskHandler}
          sx={{ color: "#dc3545!important" }}
        >
          <img src={Delete} className="mr-2" /> Delete
        </MenuItem>
      </Popover>
    </div>
  );
};

export default Task;